export const getBackgroundCssFromRenditions = backgroundImages => {
  const defaultImage = backgroundImages.find(image => !image.minWidth || !image.maxWidth);
  const mqs = backgroundImages
    .filter(image => !!image.minWidth || !!image.maxWidth)
    .reduce((images, image) => {
      const { minWidth, maxWidth, src } = image;
      const mq = [];
      if (minWidth) mq.push(`(min-width: ${minWidth}px)`);
      if (maxWidth) mq.push(`(max-width: ${maxWidth}px)`);
      const mqString = `@media screen and ${mq.join(" and ")}`;
      return {
        ...images,
        [mqString]: { backgroundImage: `url("${src}")` },
      };
    }, {});
  return {
    backgroundImage: defaultImage ? `url("${defaultImage.src}")` : null,
    ...mqs,
  };
};
